import { Component, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-close-popup',
  templateUrl: './close-popup.component.html',
  styleUrls: ['./close-popup.component.scss']
})
export class ClosePopupComponent {
  @Output() dismiss = new EventEmitter<void>(); // O tipo pode ser ajustado (ex.: string, number, etc.)

  constructor(private modalController: ModalController) {}

  dismissEvent() {
    if (this.dismiss.observers.length > 0) {
      // Se houver listeners no pai, emite o evento
      this.dismiss.emit();
    } else {
      // Se não houver listeners, executa o "dismiss normal"
      this.close();
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
